<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
        <div style="margin-right: 30px;">
          车辆编码
          <a-input class="inp ml10" placeholder="请输入" v-model:value="query.licenceNo"></a-input>
        </div>
        <div style="margin-right: 30px;">
          车辆识别码
          <a-input class="inp ml10" placeholder="请输入" v-model:value="query.vehicleVin"></a-input>
        </div>
        <div style="margin-right: 30px;">
          状态
          <a-select class="inp ml10" placeholder="请选择" v-model:value="query.status">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="0">待上传</a-select-option>
            <a-select-option value="1">已上传</a-select-option>
            <a-select-option value="2">已结案</a-select-option>
            <a-select-option value="3">已归档</a-select-option>
          </a-select>
        </div>
        <div class="ml30">
          时间
          <a-range-picker class="inp ml10"
                          v-model:value="query.accidentDateRange"
                          format="YYYY-MM-DD"></a-range-picker>
        </div>
        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <a-button class="ml24" @click="openAddModal" type="primary">人工录入</a-button>
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id" 
             :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }" :headerCellStyle="{ textAlign: 'center' }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'index'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'status'">
          <span :class="getStatusClass(record.status)">{{ getStatusText(record.status) }}</span>
        </template>
        <template v-if="column.key === 'accidentType'">
          {{ getAccidentTypeText(record.accidentType) }}
        </template>
        
        <template v-if="column.key === 'action'">
          <span>
            <a-button type="link" @click="viewDetail(record)" style="padding: 0">查看详情</a-button>
            <a-button class="ml10" v-if="record.status === 1" type="link" @click="handleUpload(record)" style="padding: 0">上传报告</a-button>
            <a-button class="ml10" v-if="record.status === 2" type="link" @click="handleClose(record)" style="padding: 0">结案</a-button>
            <a-button class="ml10" v-if="record.status === 3" type="link" @click="handleArchive(record)" style="padding: 0">归档</a-button>
          </span>
        </template>
      </template>
    </a-table>

    <!-- 人工录入事故弹框 -->
    <a-modal
      v-model:open="addModalVisible"
      title="人工录入事故"
      width="800px"
      @ok="handleAddAccident"
      @cancel="closeAddModal"
    >
      <a-form :model="addForm" layout="vertical" class="add-form">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="车辆编码" required>
              <a-select
                v-model:value="selectedVehicleId"
                show-search
                placeholder="请搜索车辆编码"
                :filter-option="false"
                :not-found-content="vehicleFetching ? undefined : null"
                :options="vehicleOptions"
                :field-names="{ label: 'label', value: 'id' }"
                @search="handleVehicleSearch"
                @change="handleVehicleChange"
                allow-clear
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="测试/运营主体" required>
              <a-input v-model:value="addForm.deptName" placeholder="选择车辆后自动填充" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="车辆识别码" required>
              <a-input v-model:value="addForm.vehicleVin" placeholder="选择车辆后自动填充" disabled />
            </a-form-item>
          </a-col>
        </a-row>
            <a-form-item label="事故类型" required>
              <a-select v-model:value="addForm.accidentType" placeholder="请选择事故类型">
                <a-select-option :value="1">碰撞</a-select-option>
                <a-select-option :value="2">刮擦</a-select-option>
                <a-select-option :value="3">追尾</a-select-option>
                <a-select-option :value="4">翻车</a-select-option>
              </a-select>
            </a-form-item>
        <a-form-item label="事故发生时间" required>
              <a-date-picker v-model:value="addForm.happenedTime" show-time format="YYYY-MM-DD HH:mm" style="width: 100%" />
            </a-form-item>
        <a-form-item label="事故发生地点" required>
          <a-input v-model:value="addForm.happenedPlace" placeholder="请输入事故发生地点" />
        </a-form-item>
        <a-form-item label="事故情况说明" required>
          <a-textarea v-model:value="addForm.accidentContext" placeholder="请输入事故情况说明" :rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>

    </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import useUserStore from '@/store/modules/user'
import { Modal, message } from 'ant-design-vue';
import { useRouter } from "vue-router";
import { selectPageList, createIncident, settleIncident, archiveIncident } from '@/api/report/incident';
import { getVehiclePageList } from "@/api/vehicle/index";

const store = useUserStore();
const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "index",
    width: 80,
    align: "center"
  },
  {
    title: "车辆编码",
    dataIndex: "licenceNo",
    key: "licenceNo",
    width: 150,
    align: "center"
  },
  {
    title: "测试/运营主体",
    dataIndex: "deptName",
    key: "deptName",
    width: 150,
    align: "center"
  },
  {
    title: "车辆识别码",
    dataIndex: "vin",
    key: "vin",
    width: 200,
    align: "center"
  },
  {
    title: "状态",
    key: "status",
    width: 100,
    align: "center"
  },
  
  {
    title: "事故发生时间",
    dataIndex: "happenedTime",
    key: "happenedTime",
    width: 180,
    align: "center"
  },
  {
    title: "事故发生地点",
    dataIndex: "happenedPlace",
    key: "happenedPlace",
    width: 320,
    align: "center"
  },
  {
    title: "事故类型",
    dataIndex: "accidentType",
    key: "accidentType",
    width: 120,
    align: "center"
  },
  {
    title: "事故情况说明",
    dataIndex: "description",
    key: "description",
    align: "center",
    width: 220,
  },
  {
    title: "操作",
    key: "action",
    width: 200,
    align: "center"
  }
];

let dataSource = ref([]);

let query = reactive({
  licenceNo: '',
  vehicleVin: '',
  status: '',
  accidentDateRange: null
});

// 新增事故弹框相关
const addModalVisible = ref(false);
const addForm = reactive({
  licenceNo: '',
  deptName: '',
  vehicleVin: '',
  accidentType: undefined,
  accidentContext: '',
  happenedPlace: '',
  happenedTime: null
});

// 车辆搜索相关
const vehicleOptions = ref([]);
const vehicleFetching = ref(false);
const selectedVehicleId = ref(undefined);
let searchTimer = null;

const handleVehicleSearch = (value) => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    fetchVehicleList(value);
  }, 300);
};

const fetchVehicleList = (sk) => {
  if (!sk) {
    vehicleOptions.value = [];
    return;
  }
  vehicleFetching.value = true;
  const data = {
    pageIndex: 1,
    pageSize: 20,
    conditionMap: { sk, dept_id: store.deptId }
  };
  getVehiclePageList(data).then((res) => {
    vehicleOptions.value = (res.data.records || []).map(v => ({
      ...v,
      label: v.licenceNo || v.vin
    }));
  }).finally(() => {
    vehicleFetching.value = false;
  });
};

const handleVehicleChange = (value) => {
  if (value) {
    const vehicle = vehicleOptions.value.find(v => v.id === value);
    if (vehicle) {
      addForm.licenceNo = vehicle.licenceNo || '';
      addForm.deptName = vehicle.deptName || '';
      addForm.vehicleVin = vehicle.vin || '';
    }
  } else {
    addForm.licenceNo = '';
    addForm.deptName = '';
    addForm.vehicleVin = '';
  }
};

const openAddModal = () => {
  addModalVisible.value = true;
  addForm.licenceNo = '';
  addForm.deptName = '';
  addForm.vehicleVin = '';
  addForm.accidentType = undefined;
  addForm.accidentContext = '';
  addForm.happenedPlace = '';
  addForm.happenedTime = null;
  selectedVehicleId.value = undefined;
  vehicleOptions.value = [];
};

const closeAddModal = () => {
  addModalVisible.value = false;
};

const handleAddAccident = async () => {
  if (!selectedVehicleId.value || !addForm.accidentType || !addForm.accidentContext || !addForm.happenedPlace || !addForm.happenedTime) {
    message.error('请填写完整信息');
    return;
  }

  try {
    const data = {
      id: null,
      vehicleId: selectedVehicleId.value,
      accidentType: addForm.accidentType,
      accidentContext: addForm.accidentContext,
      happenedPlace: addForm.happenedPlace,
      happenedTime: addForm.happenedTime.format('YYYY-MM-DD HH:mm')
    };
    const res = await createIncident(data);
    if (res.code === 200) {
      message.success('事故录入成功');
      closeAddModal();
      getData();
    }
  } catch (error) {
    console.error('事故录入失败:', error);
    message.error('事故录入失败');
  }
};

const viewDetail = (record) => {
  router.push({ path: '/report/incident/detail', query: { incidentId: record.id } });
};

const handleUpload = (record) => {
  router.push({ path: '/report/incident/edit', query: { incidentId: record.id } });
};

// 结案
const handleClose = (record) => {
  Modal.confirm({
    title: '确认结案',
    content: `确定要对事故「${record.accidentContext || record.id}」进行结案吗？`,
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const res = await settleIncident({ id: record.id });
        if (res.code === 200) {
          message.success('事故已结案');
          getData();
        }
      } catch (error) {
        console.error('结案失败:', error);
        message.error('结案失败');
      }
    }
  });
};

// 归档
const handleArchive = (record) => {
  Modal.confirm({
    title: '确认归档',
    content: `确定要对事故「${record.accidentContext || record.id}」进行归档吗？`,
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const res = await archiveIncident({ id: record.id });
        if (res.code === 200) {
          message.success('事故已归档');
          getData();
        }
      } catch (error) {
        console.error('归档失败:', error);
        message.error('归档失败');
      }
    }
  });
};

const pageChange = (page, pageSize) => {
  pagination.current = page;
  getData();
};

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
};

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.licenceNo = "";
  query.vehicleVin = "";
  query.status = "";
  query.accidentDateRange = null;
  getData();
};

const getStatusClass = (status) => {
  const statusMap = {
    0: 'status-pending',
    1: 'status-uploaded',
    2: 'status-closed',
    3: 'status-archived'
  };
  return statusMap[status] || 'status-default';
};

const getStatusText = (status) => {
  const statusMap = {
    1: '待处理',
    2: '已上传',
    3: '已结案',
    4: '已归档'
  };
  return statusMap[status] || '未知';
};

const getAccidentTypeText = (type) => {
  const typeMap = {
    1: '碰撞',
    2: '刮擦',
    3: '追尾',
    4: '翻车'
  };
  return typeMap[type] || '-';
};

const getData = async () => {
  try {
    const data = {
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      conditionMap: {
        licenceNo: query.licenceNo,
        vehicleVin: query.vehicleVin,
        status: query.status,
        startDate: query.accidentDateRange && query.accidentDateRange.length === 2 ? query.accidentDateRange[0].format('YYYY-MM-DD') : '',
        endDate: query.accidentDateRange && query.accidentDateRange.length === 2 ? query.accidentDateRange[1].format('YYYY-MM-DD') : ''
      }
    };
    const res = await selectPageList(data);
    if (res.code === 200) {
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total || 0;
    }
  } catch (error) {
    console.error('获取事故列表失败:', error);
    message.error('获取事故列表失败');
  }
};

onMounted(async () => {
  await getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    flex-wrap: wrap;
  }
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}



.accident-detail {
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.detail-row {
  display: flex;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
}

.detail-label {
  width: 120px;
  font-weight: 500;
  color: #666;
}

.detail-value {
  flex: 1;
  color: #333;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0A212E;
  background-color: #EFEFF5;
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}
</style>